import styled, { css } from 'styled-components';

import ProductResolutionImage from 'ggApp/shared/components/resolutionImage/ProductResolutionImage';
import ShimmerEffect from 'ggApp/shared/components/shimmerEffect';

const ProductImage = ShimmerEffect(ProductResolutionImage);

export const Image = styled(ProductImage)`
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

export const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    align-items: flex-start;
    justify-content: center;
`;

export const Name = styled.h3`
    ${({ theme }) => theme.typography.SuperTinyHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    overflow: hidden;
    margin-bottom: 4px;
    /* stylelint-disable */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* stylelint-enable */
`;

export const PlanTextWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

export const PlanPrice = styled.p`
    ${({ theme }) => theme.typography.SuperTinyHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-right: 4px;
`;

export const PlanDuration = styled.p`
    min-height: 18px;
    ${({ theme }) => theme.typography.TinyParagraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;

const horizontalType = css`
    padding: 12px 32px 12px 16px;
    ${Image} {
        min-width: 80px;
        min-height: 80px;
        margin-right: 12px;
        align-self: center;
    }
`;

const verticalType = css`
    flex-direction: column;
    align-items: flex-start;
    ${Image} {
        margin: 16px auto 32px;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
    }
    ${TextWrap} {
        margin-top: auto;
    }
`;

export const Wrap = styled.div`
    background: ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    padding: ${({ theme }) => theme.spacers.L};
    ${({ cardType }) => (cardType === 'horizontal' && horizontalType)
        || (cardType === 'vertical' && verticalType)}
`;

